import Base from './Base.js';

class FinanceApi extends Base {
  currency(params) {
    return this.apiClient.get('rates/nbrk', params);
  }

  chart(currency, period) {
    return this.apiClient.get(`rates/nbrk/history/${currency}/${period}`);
  }

  banks(currency, params) {
    return this.apiClient.get(`rates/banks/${currency}`, params);
  }

  banksLocation() {
    return this.apiClient.get('rates/available/cities');
  }

  bankBranches(bankId, params) {
    return this.apiClient.get(`rates/banks/${bankId}/branches`, params);
  }

  listOfActiveCurrencies(params) {
    return this.apiClient.get('rates/available/currencies', params);
  }

  getBestRates(params) {
    return this.apiClient.get('rates/banks/best', params);
  }

  sendCurrencyAuctionForm(payload, accessToken) {
    return this.apiClient.post('auctions', payload, accessToken);
  }

  currencyAuctionConfig() {
    return this.apiClient.get('auctions/config');
  }
}

export default FinanceApi;
